import { render, staticRenderFns } from "./AssociationTable.vue?vue&type=template&id=c33ac40e&scoped=true"
import script from "./AssociationTable.vue?vue&type=script&lang=ts"
export * from "./AssociationTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33ac40e",
  null
  
)

export default component.exports